import React from "react";

export const GlassCard = ({ className = "", hover = true, children, ...props }) => (
  <div
    className={`kk-glass ${hover ? "kk-glass-hover" : ""} ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default GlassCard;
